import { Button } from '@/common/ui/button'
import { useSearchParams } from 'react-router-dom'
import { useEffect } from 'react'

export default function ProviderGameTypeSelector() {
	const [searchParams, setSearchParams] = useSearchParams()

	// Set default to SLOT if no providerGameType parameter exists
	useEffect(() => {
		if (!searchParams.get('providerGameType')) {
			setSearchParams({ providerGameType: 'SLOT' })
		}
	}, [searchParams, setSearchParams])

	const currentGameType = searchParams.get('providerGameType') || 'SLOT'

	return (
		<div className="flex flex-wrap items-center gap-2">
			<Button
				variant="secondary"
				isActive={currentGameType === 'SLOT'}
				onClick={() => setSearchParams({ providerGameType: 'SLOT' })}
			>
				สล็อต
			</Button>
			<Button
				variant="secondary"
				isActive={currentGameType === 'CASINO'}
				onClick={() => setSearchParams({ providerGameType: 'CASINO' })}
			>
				คาสิโน
			</Button>
			<Button
				variant="secondary"
				isActive={currentGameType === 'SPORT'}
				onClick={() => setSearchParams({ providerGameType: 'SPORT' })}
			>
				กีฬา
			</Button>
			<Button
				variant="secondary"
				isActive={currentGameType === 'LOTTO'}
				onClick={() => setSearchParams({ providerGameType: 'LOTTO' })}
			>
				หวย
			</Button>
			<Button
				variant="secondary"
				isActive={currentGameType === 'FISHING'}
				onClick={() => setSearchParams({ providerGameType: 'FISHING' })}
			>
				ยิงปลา
			</Button>
		</div>
	)
}
